import { render, staticRenderFns } from "./vx_notification.vue?vue&type=template&id=3cb0127c&scoped=true&"
import script from "./vx_notification.vue?vue&type=script&lang=js&"
export * from "./vx_notification.vue?vue&type=script&lang=js&"
import style0 from "./vx_notification.vue?vue&type=style&index=0&id=3cb0127c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb0127c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oem/work/Rails/tosdere_erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3cb0127c', component.options)
    } else {
      api.reload('3cb0127c', component.options)
    }
    module.hot.accept("./vx_notification.vue?vue&type=template&id=3cb0127c&scoped=true&", function () {
      api.rerender('3cb0127c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/utils/vx_notification.vue"
export default component.exports